import baseStorage from './baseStorage'
export default {
    keyword: 'userToken',
    setToken(value) {
        baseStorage.setStorage(this.keyword, value)
    },
    getToken() {
        return baseStorage.getStorage(this.keyword);
    },
    tokenTimeKeyword: 'userTokenTime',
    setTokenTime(value) {
        baseStorage.setStorage(this.tokenTimeKeyword, value)
    },
    getTokenTime() {
        return baseStorage.getStorage(this.tokenTimeKeyword);
    },
    removeToken() {
        baseStorage.removeStorage(this.keyword);
    }
}


// WEBPACK FOOTER //
// ./src/utils/storage/tokenStorage.js